<!--
  Badge global de estado de sincronizacion (Paso 8 / Fase 6).
  Cuenta en vivo (Dexie liveQuery) las filas de la outbox que todavia no se
  confirmaron y colorea segun severidad:
    - ROJO  si hay conflict|error (algo NO se sincronizo y necesita atencion).
    - AMBAR si solo hay pending|in_flight (se sincronizara solo).
  Al tocarlo abre el drawer de sync (lista + acciones), no drena directo: el
  drenado automatico ya corre al boot / evento online / tras cada alta.
-->
<script>
    import { liveQuery } from "dexie";
    import { outboxDb } from "$lib/outbox/outboxDb";
    import { syncUi } from "$lib/stores/syncUi.svelte.js";
    import { viewport } from "$lib/stores/viewport.svelte";

    // En celu tiene que despejar la NavegacionBottom (--cf-nav-h) + la
    // safe-area inferior, o queda debajo de la barra del sistema; en
    // escritorio (sin barra inferior) se apoya abajo. Igual que
    // BarraAccionesSeleccion.
    let esCelu = $derived(viewport.esCelu);

    const counts = liveQuery(async () => {
        const rows = await outboxDb.outbox
            .where("status")
            .anyOf(["pending", "in_flight", "error", "conflict"])
            .toArray();
        let amber = 0;
        let red = 0;
        for (const r of rows) {
            if (r.status === "conflict" || r.status === "error") red++;
            else amber++;
        }
        return { amber, red, total: rows.length };
    });
</script>

{#if $counts && $counts.total > 0}
    {@const hasProblem = $counts.red > 0}
    <button
        type="button"
        onclick={() => syncUi.openDrawer()}
        title={hasProblem
            ? "Hay cambios que no se pudieron sincronizar. Tocá para ver el detalle."
            : "Hay cambios esperando sincronizar. Tocá para ver el detalle."}
        class="fixed right-4 z-50 flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium text-white shadow-lg {hasProblem
            ? 'bg-cf-danger hover:bg-cf-danger'
            : 'bg-amber-500 hover:bg-amber-600'}"
        style={`bottom: ${esCelu ? "calc(var(--cf-nav-h) + 1rem + var(--cf-safe-bottom))" : "1rem"}`}
    >
        <span
            class="inline-block h-2 w-2 animate-pulse rounded-full bg-white"
        ></span>
        {#if hasProblem}
            {$counts.red}
            {$counts.red === 1 ? "cambio con problema" : "cambios con problema"}
        {:else}
            {$counts.amber}
            {$counts.amber === 1
                ? "cambio sin sincronizar"
                : "cambios sin sincronizar"}
        {/if}
    </button>
{/if}
